import { jsx } from "react/jsx-runtime";
import React, { forwardRef, useState, useRef } from "react";
import { clamp, round } from "lodash";
import { cn as clsx } from "../../helpers/react.js";
import { useResizeObserver } from "../../hooks/useResizeObserver.js";
import '../../assets/index33.css';const svgPaneContainer = "_svgPaneContainer_1iqul_1";
const svgPane = "_svgPane_1iqul_1";
const disabled = "_disabled_1iqul_13";
const styles = {
  svgPaneContainer,
  svgPane,
  disabled
};
const SVGContext = React.createContext({});
const normalizeRelativeCord = (v) => clamp(round(v, 4), 0, 1);
const RawSVGPane = forwardRef((props, forwardedRef) => {
  const { children, onClick, onMouseDown, onMouseUp, onMouseMove, disabled: disabled2, svgProps = {} } = props;
  const [contextValue, setContextValue] = useState(null);
  const internalRef = useRef(null);
  const ref = forwardedRef || internalRef;
  useResizeObserver(ref, (el) => {
    if (!el) {
      return;
    }
    setContextValue({
      getAbsoluteCords: ([x, y]) => {
        const rect = el.getBoundingClientRect();
        return [x * rect.width, y * rect.height];
      },
      getRelativeCords: ([x, y]) => {
        const rect = el.getBoundingClientRect();
        x = normalizeRelativeCord((x - rect.left) / rect.width);
        y = normalizeRelativeCord((y - rect.top) / rect.height);
        return [x, y];
      },
      getPaneRect: () => el.getBoundingClientRect()
    });
  });
  return /* @__PURE__ */ jsx("div", { className: styles.svgPaneContainer, ref, children: /* @__PURE__ */ jsx(
    "svg",
    {
      ...svgProps,
      className: clsx(styles.svgPane, { [styles.disabled]: disabled2 }),
      onClick: (ev) => contextValue && (onClick == null ? void 0 : onClick(contextValue.getRelativeCords([ev.clientX, ev.clientY]), ev)),
      onMouseDown: (ev) => contextValue && (onMouseDown == null ? void 0 : onMouseDown(contextValue.getRelativeCords([ev.clientX, ev.clientY]), ev)),
      onMouseUp: (ev) => contextValue && (onMouseUp == null ? void 0 : onMouseUp(contextValue.getRelativeCords([ev.clientX, ev.clientY]), ev)),
      onMouseMove: (ev) => contextValue && (onMouseMove == null ? void 0 : onMouseMove(contextValue.getRelativeCords([ev.clientX, ev.clientY]), ev)),
      children: contextValue && /* @__PURE__ */ jsx(SVGContext.Provider, { value: contextValue, children })
    }
  ) });
});
const SVGPane = Object.assign(RawSVGPane, {
  SVGContext
});
export {
  SVGPane
};
